{
  "de": {
    "help": {
      "headings": {
        "additionalModelsNote": "Darüber hinaus stehen weitere Modelle mit unterschiedlichen Eigenschaften zur Verfügung.",
        "contact": "Deine Frage war nicht dabei?",
        "contactSubtitle": "Kontaktiere uns - wir helfen dir gern weiter.",
        "currentTextModels": "Aktuelle Textmodelle",
        "free": "Diese Limits gelten für dich mit deiner aktuellen Lizenz:",
        "imageModels": "Bildmodelle",
        "imageModelsIntro": "Diese Modelle können Bilder aus Textbeschreibungen generieren.",
        "ttsModels": "Text-zu-Sprache Modelle",
        "ttsModelsIntro": "Diese Modelle können Text in natürlich klingende Sprache umwandeln.",
        "transcriptionModels": "Transkriptions-Modelle",
        "transcriptionModelsIntro": "Diese Modelle können Audioaufnahmen in Text transkribieren.",
        "languageModelIntro": "Fobizz stellt verschiedene KI-Modelle zur Verfügung. Dabei werden immer möglichst aktuelle und leistungsstarke Modelle eingebunden. Voraussetzung dafür ist immer, dass Modelle mit unseren Datenschutzauflagen kompatibel sind und dass genügend Kapazitäten für die Anforderungen von fobizz zur Verfügung stehen. Da neue Modelle von den Anbietern in unregelmäßigen Abständen veröffentlicht werden, gibt es dafür keinen festen Turnus - wir prüfen jedes neue Modell zeitnah und binden es ein, sobald die genannten Voraussetzungen erfüllt sind.",
        "languageModelVideoIntro": "Welches Modell passt zu meiner Aufgabe?",
        "languageModelVideoDescription": "Im folgenden Video erklären wir die Unterschiede zwischen offenen und geschlossenen Modellen, schnellen kleinen Modellen und leistungsstarken Reasoning-Modellen — und wann sich welches Modell am besten eignet.",
        "languageModels": "Textmodelle",
        "largeModel": "Ein großes Modell",
        "largeModelDescription": "liefert detailreichere Antworten. Dieses Modell ist besonders geeignet für Anfragen, die mehr Detailtiefe und die Verarbeitung größerer Zusammenhänge erfordern.",
        "limits": "Limits",
        "modelCards": "Übersicht KI-Modelle",
        "modelTypesIntro": "Fobizz bevorzugt offene Modelle und empfiehlt im KI Chat immer zwei Alternativen in dieser Reihenfolge:",
        "openSourceLanguageModels": "Open Source Modelle",
        "plugins": "Plugins",
        "proprietaryLanguageModels": "Proprietäre Modelle",
        "reasoningModel": "Ein Reasoning Modell",
        "reasoningModelDescription": "hat besondere analytische Fähigkeiten. Dieses Modell ist besonders geeignet für komplexe Aufgaben, die mehrstufige logische Denkprozesse und Schlussfolgerungen erfordern.",
        "references": "Quellen",
        "searchResults": "Suchergebnisse",
        "smallModel": "Ein kleines Modell",
        "smallModelDescription": "ist besonders schnell und effiziert. Dieses Modell ist besonders geeignet für schnelle Dialoge, inhaltliche Aufgaben und einfache Antworten.",
        "subtitle": "Hinweise und Antworten vom fobizz Team",
        "welcome": "Willkommen zur fobizz Hilfe"
      },
      "chatbot": {
        "title": "Frage den Helpcenter Chatbot",
        "description": "Stelle deine Frage unserem Chatbot, der dir Auskunft über alle Themen rund um fobizz und die fobizz Tools geben kann.",
        "url": "https://app.fobizz.com/ai/chats/public_assistants/d6272da2-35ae-4b68-8594-14a0da9d4029?token=ef7ab9adca3e758f0aa7d6808605c6a9"
      },
      "labels": {
        "articles": "0 Artikel | 1 Artikel | {count} Artikel",
        "contextWindow": "Kontextfenster",
        "input": "Eingabe",
        "knowledgeCutoff": "Wissensschwelle",
        "lastUpdated": "Zuletzt aktualisiert am",
        "maxTokens": "Maximale Token",
        "modelCardUrl": "Referenzdokumentation",
        "opensInNewTab": "öffnet in neuem Tab",
        "reasoning": "Reasoning",
        "recommended": "Empfohlen",
        "searchResults": "Fragen & Antworten"
      },
      "links": {
        "allCategories": "Alle Kategorien",
        "backToHelp": "Zurück zur Hilfe"
      },
      "paragraphs": {
        "contactEmail": "Schreibe uns eine E-Mail.",
        "contactPhone": "Rufe uns an: Mo bis Fr 8-16 Uhr",
        "contactSales": "Beratungstermin vereinbaren",
        "contactSchoolLicense": "Für Fragen zu Schullizenzen",
        "disclaimer": "Alle hier aufgeführten Sprachmodelle werden in <strong>europäischen</strong> bzw. <strong>deutschen</strong> Rechenzentren gehostet - mit Ausnahme der Modelle von <strong>OpenAI</strong> und <strong>Anthropic</strong>.",
        "intro": "Mit einem kostenfreien Konto kannst du fobizz unverbindlich testen, einen Ausschnitt des Fortbildungskatalogs nutzen und erhältst ein monatliches Limit für die Tools.",
        "outro": "Einmal angelegte Inhalte kannst du auch über das Ende eines Abos oder einer Schullizenz hinaus weiterhin nutzen. Genaue Infos zu den Konditionen der verschiedenen fobizz Angebote findest du in der <a href=\"https://plattform.fobizz.com/preistabelle\" target=\"_blank\">Preistabelle</a>.",
        "plugins": "Alle Modelle, die kompatibel mit Plugins sind, haben automatisch Zugriff auf die folgenden Integrationen. Die folgenden Plugins sind aktuell verfügbar und können die Fähigkeiten von KI-Assistenten deutlich verbessern.",
        "recommendedForHelp": "Die Vorschläge basieren auf deinen <a href=\"{profileSettingsUrl}\" target=\"_blank\">Profileinstellungen</a>.<br>Pass sie gerne an."
      },
      "search": {
        "noResults": "Leider gab es keine exakten Treffer. Bitte versuche ein anderes Stichwort oder eine andere Schreibweise."
      },
      "table": {
        "contextWindow": "Kontextfenster",
        "featureNames": "Funktionen",
        "maxTokens": "Maximale Token",
        "model": "Model",
        "openSource": "Offen",
        "provider": "Provider",
        "reasoning": "Reasoning",
        "supportsFunctions": "Plugins",
        "supportsVision": "Bildverarbeitung",
        "supportsImageGeneration": "Generierung",
        "sizes": "Größen"
      }
    }
  }
}
